<script>
	const metadata = require('core/metadata');
	const moment = require('moment');
	const utilities = require('utilities');
	const model = require('model/model');

	const visitor = metadata.visitorPopup;
	let body = null;
	let headline = null;
	let linkCode = null;
	let linkText = null;
	let linkUrl = null;
	let linkOpensNewTab = null;
	let startDate = null;
	let vimeoId = null;

	if (visitor) {
		body = visitor.body;
		headline = visitor.headline;
		linkCode = visitor.linkCode;
		linkText = visitor.linkText;
		linkUrl = visitor.linkUrl;
		linkOpensNewTab = visitor.linkOpensNewTab;
		startDate = visitor.startDate;
		vimeoId = visitor.vimeoId;
	}

	module.exports = {
		modelData: ['visitorDismiss', 'userContext'],
		components: {
			modal: require('./modal.vue').default,
			'outbound-link': require('./outbound-link.vue').default
		},
		data() {
			let target = linkOpensNewTab ? '_blank' : '_self';
			return {
				body,
				headline,
				linkCode,
				linkText,
				linkUrl,
				target,
				startDate,
				vimeoId
			};
		},
		mounted() {
			this.$subscribe('modal-closed', id => {
				if (id !== 'visitor-modal') {
					return true; // let some other handler take this
				}

				let player = this.$refs.player;
				if (player && player.pause) {
					player.pause();
				}

				model.set('visitorDismiss', startDate);

				return false;
			});
			this.shouldShowModal();
		},
		methods: {
			shouldShowModal() {
				let userContext = this.userContext;
				let now = moment();
				let startMoment = moment(startDate);
				let newMessageToUser = !this.visitorDismiss || moment(this.visitorDismiss) < startMoment;
				let loginRequest = window.location.hash === '#login';
				// Only show logged in users once per session
				if (!userContext && !loginRequest && startDate && startMoment < now && newMessageToUser) {
					utilities.openModal('#visitor-modal');
				}
			},
			close() {
				utilities.closeModals();
			},
			onLinkClick() {
				if (!linkOpensNewTab) {
					this.dismissWhatsNewModal();
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	#visitor-modal {
		.modal-window-wrap {
			max-width: 800px;

			.vimeo-player {
				width: 100%;
				min-height: 480px;
			}

			.modal-content-main {
				min-height: 480px;

				p {
					margin-bottom: 0rem;
				}

				.link-container {
					margin: 1rem 0 0.5rem 0;
					text-align: center;
				}
			}
		}

		.dismiss-visitor {
			cursor: pointer;

			&:hover {
				color: $c-slate-dark;
				text-decoration: underline;
			}
		}
	}
</style>
<template>
	<modal
		ref="modal"
		id="visitor-modal"
		:ok="false">
		<template slot="header-container">
			<h2 v-html="headline"></h2>
		</template>
		<template slot="content">
			<div class="modal-content-body">
				<div
					class="rte"
					v-if="body"
					v-html="body"></div>
				<vimeo-player
					v-if="vimeoId"
					ref="player"
					:video-id="vimeoId"></vimeo-player>
				<template v-if="linkText && linkUrl">
					<p class="link-container">
						<a
							v-if="!linkCode"
							:href="linkUrl"
							:target="target"
							class="link button"
							@click="onLinkClick"
							v-html="linkText">
						</a>
						<outbound-link
							v-if="linkCode"
							class="link button"
							:href="linkUrl"
							:data-outbound-link="linkCode"
							:target="target"
							:on-click="onLinkClick">
							<span v-html="linkText"></span>
						</outbound-link>
					</p>
				</template>
				<div class="text-centered">
					<button
						class="button"
						:class="{
							'-small': linkText && linkUrl,
							'-outline': linkText && linkUrl
						}"
						@click="close">
						Close
					</button>
				</div>
			</div>
		</template>
	</modal>
</template>
